import * as constants from './constants';

export function getPaymentInfo() {
  return {
    type: constants.GET_PAYMENT_INFO_REQUEST,
    isFetching: true,
  };
}

export function getPaymentInfoError(error) {
  return {
    type: constants.GET_PAYMENT_INFO_FAILURE,
    isFetching: false,
    errorMessage: error,
  };
}

export function getPaymentInfoSuccess(data) {
  return {
    type: constants.GET_PAYMENT_INFO_SUCCESS,
    isFetching: false,
    errorMessage: null,
    data,
  };
}

export function savePaymentInfo(attributes) {
  return {
    type: constants.SAVE_PAYMENT_INFO_REQUEST,
    isFetching: true,
    saveSuccess: false,
    attributes,
  };
}

export function savePaymentInfoError(error) {
  return {
    type: constants.SAVE_PAYMENT_INFO_FAILURE,
    isFetching: false,
    errorMessage: error,
  };
}

export function savePaymentInfoSuccess(data) {
  return {
    type: constants.SAVE_PAYMENT_INFO_SUCCESS,
    isFetching: false,
    errorMessage: null,
    saveSuccess: true,
    data,
  };
}



// WEBPACK FOOTER //
// ./src/containers/PaymentInfo/actions.js